import React, { useState } from "react";
import "./Filter_Drop.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSortDown } from "@fortawesome/free-solid-svg-icons";
import DateFilterOffcanvas from "./DateFilterOffcanvas/DateFilterOffcanvas";
import WithdrawalFilterOffcanvas from "./WithdrawalFilterOffcanvas/WithdrawalFilterOffcanvas";

function Filter_Drop({
  options,
  showDate,
  setShowDate,
  showFilter,
  setShowFilter,
  selectedDate,
  setSelectedDate,
  selectedApp,
  setSelectedApp,
  ...props
}) {
  const handleShow = () => setShowFilter(true);
  const handleClose = () => setShowFilter(false);
  return (
    <>
      <section className="Filter_Drop">
        <div className="filter-row">
          {selectedApp && (
            <div className="filter-item" onClick={handleShow}>
              <span>{selectedApp?.label || "All"}</span>
              <FontAwesomeIcon icon={faSortDown} />
            </div>
          )}
          {/* {selectedDate && ( */}
          <div className="filter-item" onClick={() => setShowDate(true)}>
            <span>{selectedDate ? selectedDate : "Select Date"}</span>
            <FontAwesomeIcon icon={faSortDown} />
          </div>
          {/* )} */}
        </div>
      </section>

      <DateFilterOffcanvas
        show={showDate}
        handleClose={() => {
          // setSelectedDate("");
          setShowDate(false);
        }}
        onApplyDate={setSelectedDate}
        disableFuture={true}
      />
      <WithdrawalFilterOffcanvas
        options={options}
        show={showFilter}
        handleClose={handleClose}
        onApplyApp={setSelectedApp}
      />
    </>
  );
}

export default Filter_Drop;
